<template>
  <recent-activity-table :data="dashboardEvents"></recent-activity-table>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import RecentActivityTable from "./recentActivityTable/RecentActivityTable";

export default {
  components: {
    RecentActivityTable
  },
  methods: mapActions(["fetchDashboardStatistics"]),
  computed: mapGetters(["dashboardEvents"]),
  created() {
    this.fetchDashboardStatistics();
  }
};
</script>
